<template>
  <form class="treeline row column-s grid-12 align-center" @submit="submit" onsubmit="return false">
    <div class="row align-center grid-12">
      <div class="column grow-1">
        <div class="row row-1 align-center">
          <select class="input" v-model="newItem.type" v-if="isNew" @change="list()" required>
            <option value="">Tipo</option>
            <template v-if="item.title == 'especialidades'">
              <option value="especialidade">Especialidade</option>
              <option value="area">Área</option>
              <option value="competencia">Competência</option>
            </template>
            <template v-if="item.title == 'certificados'">
              <option value="certificadora">Certificadora</option>
              <option value="certificado">Certificado</option>
            </template>
            <template v-if="item.title == 'ferramentas'">
              <option value="tipo_ferramenta">Tipo ferramenta</option>
              <option value="ferramenta">Ferramenta</option>
            </template>
          </select>
          <select v-if="newItem.type == 'competencia' || newItem.type == 'area'" @change="loadArea()"
            v-model="newItem.id_especialidade" class="input" required>
            <option value="0">Especialidades</option>
            <option v-for="(e, i) of especialidades" :key="'e-new' + i" :value="e.id">
              {{ e.nome }}
            </option>
          </select>
          <select v-if="newItem.type == 'competencia' && newItem.id_especialidade > 0" v-model="newItem.id_area"
            class="input" required>
            <option value="0">Área</option>
            <option v-for="(e, i) of areas" :key="'e-new' + i" :value="e.id">
              {{ e.nome }}
            </option>
          </select>
          <select v-if="newItem.type == 'certificado' || newItem.id_certificadora > 0"
            v-model="newItem.id_certificadora" class="input" required>
            <option value="0">Certificadora</option>
            <option v-for="(certificater, i) of certificaters" :key="'certificater-new' + i" :value="certificater.id">
              {{ certificater.nome }}
            </option>
          </select>
          <select v-if="
            newItem.type == 'ferramenta' || newItem.id_tipo_ferramenta > 0" v-model="newItem.id_tipo_ferramenta"
            class="input" required>
            <option value="0">Tipo Ferramenta</option>
            <option v-for="(tooltype, i) of tooltypes" :key="'tooltype-new' + i" :value="tooltype.id">
              {{ tooltype.nome }}
            </option>
          </select>
          <input v-if="(newItem.type == 'certificadora' || newItem.type == 'tipo_ferramenta' || newItem.type == 'especialidade') ||
            newItem.nome.length ||
            (newItem.type == 'ferramenta' && newItem.id_tipo_ferramenta > 0) ||
            (newItem.type == 'certificado' && newItem.id_certificadora > 0) ||
            (newItem.type == 'area' && newItem.id_especialidade > 0) ||
            (newItem.type == 'competencia' && newItem.id_especialidade > 0 && newItem.id_area > 0)
          " type="text" class="input" placeholder="Nome" v-model="newItem.nome" required />
        </div>
        <div class="row-2" v-if="
          newItem.descricao ||
          newItem.type == 'certificado' ||
          newItem.type == 'ferramenta' ||
          (newItem.type == 'competencia' && newItem.id_area > 0)
        ">
          <input type="text" class="input" placeholder="Descrição" v-model="newItem.descricao" required />
        </div>
      </div>
      <div class="historic column">
        <div class="date" v-if="item.criado_em">
          <label>Criado em:</label><br />
          <b>{{ item.criado_em | date }}</b> por <b>{{ item.nome_criado_por || item.criado_por }}</b>
        </div>
        <div class="date date-2" v-if="item.alterado_em">
          <label>Alterado em:</label><br />
          <b>{{ item.alterado_em | date }}</b> por
          <b>{{ item.nome_alterado_por || item.alterado_por }}</b>
        </div>
      </div>
    </div>
    <Button layout="green-go" v-if="
      isNew &&
      !loader &&
      newItem.nome &&
      (newItem.type == 'certificadora' || newItem.type == 'tipo_ferramenta' || newItem.type == 'especialidade')
    " @click="call('create')" type="submit">CRIAR</Button>
    <Button layout="green-go" v-if="
      isNew &&
      !loader &&
      newItem.nome &&
      (newItem.id_certificadora > 0 || newItem.id_tipo_ferramenta > 0 || newItem.id_especialidade > 0) &&
      (newItem.type == 'certificado' || newItem.type == 'ferramenta' || newItem.type == 'area' || newItem.type == 'competencia')
    " @click="call('create')" type="submit">CRIAR</Button>

    <Loader layout="small" v-if="loader" />
    <i class="fa fa-check text-green font-25" v-if="item.nome && !loader && !isNew" title="SALVAR"
      @click="call('update')" type="submit" />
    &nbsp; &nbsp;
    <i class="fa fa-trash text-red font-20" v-if="!isNew && !loader" title="EXCLUIR" @click="call('del')" />
  </form>
</template>

<script>
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import { mapActions } from "vuex";

export default {
  name: "TreeLine",
  components: { Button, Loader },
  props: { item: Object, isNew: Boolean, index: Number },
  data() {
    return {
      loader: false,
      newItem: {
        type: "",
        nome: "",
        descricao: "",
        id_certificadora: 0,
        id_tipo_ferramenta: 0,
        id_especialidade: 0,
        id_area: 0
      },
      especialidades: [],
      certificaters: [],
      areas: [],
      tooltypes: [],
    };
  },
  methods: {
    ...mapActions("admin", ["ESPECIALITY_LIST", "CERTIFICATERS_LIST", "TOOLTYPES_LIST", "AREAS_LIST"]),
    submit() {
      if (this.isNew) this.create();
      else this.update();
    },
    loadArea() {
      if (this.newItem.type == "competencia")
        this.AREAS_LIST({ id_especialidade: this.newItem.id_especialidade }).then(({ data }) => this.areas = data || [])
    },
    list() {
      if (this.item.title == "especialidades")
        this.ESPECIALITY_LIST().then((r) => {
          if (r.status == 200) this.especialidades = r.data;
        });
      if (this.item.title == "certificados")
        this.CERTIFICATERS_LIST().then((r) => {
          if (r.status == 200) this.certificaters = r.data;
        });
      if (this.item.title == "ferramentas")
        this.TOOLTYPES_LIST().then((r) => {
          if (r.status == 200) this.tooltypes = r.data;
        });
    },
    reset() {
      this.newItem = {
        type: "",
        nome: "",
        descricao: "",
        id_certificadora: 0,
        id_tipo_ferramenta: 0,
        id_especialidade: 0,
        id_area: 0
      };

      if (this.isNew) this.$parent.newItem = false;
    },
    async call(func) {
      this.loader = true;
      if (func == 'del' && confirm("Você realmente deseja excluir esse item?"))
        (await this.item[func](this.newItem), this.item.reload())

      if (func != "del")
        (await this.item[func](this.newItem), this.item.reload())

      if (this.isNew) this.reset();
      this.item.newItem = false;
      this.loader = false
    },
  },
  beforeMount() {
    this.list()
    if (this.item) this.newItem = { ...this.newItem, ...this.item };
    this.loadArea()
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.treeline {
  color: $gray-6;

  .button {
    font-size: 12px;
  }

  select {
    @media (max-width: $small) {
      width: 100% !important;
    }
  }

  .row-1 {
    .input {
      @media (min-width: $small) {
        margin-right: 15px;
        /* max-width: 25%; */
        height: 31px;
      }

      @media (max-width: $small) {
        margin-bottom: 25px;
        width: 96%;
      }
    }
  }

  .row-2 {
    padding: 7px 0px;
    padding-right: 16px;
  }

  .historic {
    margin-top: -4px;

    .date {
      font-size: 13px;
      font-weight: 500;
      margin-right: 20px;

      label {
        font-size: 10px;
      }

      &-2 {
        margin-top: 9px;
      }
    }
  }

  .fa-times {
    margin-left: 15px;
  }
}
</style>